import React from 'react';
import { Box, SxProps } from '@mui/material';

function HubSectionContainer({
  children, sx, wide, backgroundContrast,
}: {
  children: React.ReactNode, sx?: SxProps, wide?: boolean, backgroundContrast?: boolean,
}) {
  // Full-bleed background layer; content is centred inside.
  const wideSettings = {
    width: '100%',
  } as const;
  const narrowSettings = {
    px: 2,
    maxWidth: 900,
    mx: 'auto',
    width: '100%',
  } as const;

  // Design-system page frame: content capped at 1250px with 76px edge margins on
  // desktop (Figma "Container" = 1250 content + 2×76 gutters).
  const wideContent = {
    maxWidth: 1250 + 76 * 2,
    mx: 'auto',
    width: '100%',
    px: { xs: 2, md: '76px' },
  } as const;

  return (
    <Box sx={{ ...(wide ? wideSettings : narrowSettings), background: backgroundContrast ? '#F6F5FA' : '' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          ...(wide && wideContent),
          ...(sx || {}),
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default HubSectionContainer;
